import { render } from "./VerifySecurity.vue?vue&type=template&id=fcb0d19a&scoped=true&ts=true"
import script from "./VerifySecurity.vue?vue&type=script&lang=ts"
export * from "./VerifySecurity.vue?vue&type=script&lang=ts"

import "./VerifySecurity.vue?vue&type=style&index=0&id=fcb0d19a&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb0d19a"]])

export default __exports__